export default __webpack_public_path__ + "static/media/12.f08db626.png";